import { Group, Text } from '@mantine/core';
import { memo } from 'react';

import { CommonAdvice } from '@advices/data-access';
import { FieldConnectionIndicators, TsrButtonLink } from '@ui';

interface FieldNameCellProps {
  rowId: string;
  value: string;
  type: string;
  field?: CommonAdvice['field'];
}

export const FieldNameCell = memo(
  ({ rowId, value, type, field }: FieldNameCellProps) => {
    const hasConnections = field?.wiuz_id != null || field?.jd_id != null;

    return (
      <Group gap={0} style={{ position: 'relative', width: '100%' }}>
        <TsrButtonLink
          fullWidth
          justify="start"
          maw={250}
          ml="calc(var(--button-padding-x-compact-md) * -1)"
          params={{ resultId: rowId.toString(), type: type }}
          size="compact-md"
          td="underline"
          to="/precifert-n/$type/results/$resultId"
          tt="capitalize"
          variant="subtle"
        >
          <Group gap="xs" wrap="nowrap" style={{ position: 'relative', alignItems: 'center', width: '100%' }}>
            <Text span truncate="end" style={{ flex: 1, minWidth: 0, paddingRight: hasConnections ? '16px' : '0' }}>
              {value}
            </Text>
            {field && (
              <FieldConnectionIndicators wiuzId={field.wiuz_id} jdId={field.jd_id} />
            )}
          </Group>
        </TsrButtonLink>
      </Group>
    );
  },
);
